import { t } from 'i18next'
import { z } from 'zod'

export const PatientComorbidity = z.object({
  id: z.string(),
  name: z.string(),
  createdAt: z.string()
})
export type PatientComorbidity = z.infer<typeof PatientComorbidity>

export const PatientComorbidities = z.array(PatientComorbidity)
export type PatientComorbidities = z.infer<typeof PatientComorbidities>

export const CreatePatientComorbidityDTO = z.object({
  name: z
    .string()
    .min(1, {
      message: t('general.form.required')
    })
    .max(50)
})
export type CreatePatientComorbidityDTO = z.infer<
  typeof CreatePatientComorbidityDTO
>
